module.exports = __webpack_public_path__ + "img/transactions.9c8efc57.svg";